import { Box, Link, Text } from '@chaine/keychaine'
import React from 'react'

export function ModalFooter({ formError }: { formError: string | React.ReactNode }) {
  return (
    <Box>
      <Text color="red.600">{formError}</Text>
      <Text>
        {`See `}
        <Link
          color="blue.600"
          href="https://handbook.chaineapp.com/product-guide/apps/four-kites"
          target="_blank"
          rel="noopener noreferrer"
        >
          detailed steps here.
        </Link>
      </Text>
    </Box>
  )
}
